module.exports = __webpack_public_path__ + "img/flag-swallowtail.34748f69.svg";